// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1gpSU","productName":"Table_productName__34zkg"};